/**
 * Recipe facet keys in display order.
 *
 * Shared between the API layer (requests these facets from Algolia) and the
 * RecipeCategory view (renders filter groups in this order).
 */
export const RECIPE_FACETS: Array<string> = [
  'mealType',
  'complexity',
  'hardwood',
  'holiday',
  'cookingMethod',
  'diet',
];
